import { render, staticRenderFns } from "./RequestCustomerLink.vue?vue&type=template&id=cf5aac68&"
import script from "./RequestCustomerLink.vue?vue&type=script&lang=ts&"
export * from "./RequestCustomerLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports